
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Role = {
  PATIENT: 'PATIENT',
  THERAPIST: 'THERAPIST',
  SUPER_ADMIN: 'SUPER_ADMIN'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
  PREFER_NOT_TO_SAY: 'PREFER_NOT_TO_SAY'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]


export const MinorGuardianConsentStatus = {
  ACTIVE: 'ACTIVE',
  REVOKED: 'REVOKED'
} as const

export type MinorGuardianConsentStatus = (typeof MinorGuardianConsentStatus)[keyof typeof MinorGuardianConsentStatus]


export const MinorGuardianRelationship = {
  PARENT: 'PARENT',
  GUARDIAN: 'GUARDIAN',
  OTHER_LEGAL_REPRESENTATIVE: 'OTHER_LEGAL_REPRESENTATIVE'
} as const

export type MinorGuardianRelationship = (typeof MinorGuardianRelationship)[keyof typeof MinorGuardianRelationship]


export const TherapistDocumentType = {
  CONTRACT: 'CONTRACT',
  W8_BEN: 'W8_BEN',
  W8_BEN_E: 'W8_BEN_E'
} as const

export type TherapistDocumentType = (typeof TherapistDocumentType)[keyof typeof TherapistDocumentType]


export const TherapyRelationshipStatus = {
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  ENDED: 'ENDED'
} as const

export type TherapyRelationshipStatus = (typeof TherapyRelationshipStatus)[keyof typeof TherapyRelationshipStatus]


export const TherapyRelationshipType = {
  INDIVIDUAL: 'INDIVIDUAL',
  COUPLES: 'COUPLES'
} as const

export type TherapyRelationshipType = (typeof TherapyRelationshipType)[keyof typeof TherapyRelationshipType]


export const AdditionalServicePaymentStatus = {
  PAID: 'PAID',
  REFUNDED: 'REFUNDED'
} as const

export type AdditionalServicePaymentStatus = (typeof AdditionalServicePaymentStatus)[keyof typeof AdditionalServicePaymentStatus]


export const TherapistReportStatus = {
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAID: 'PAID',
  IN_PROGRESS: 'IN_PROGRESS',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED'
} as const

export type TherapistReportStatus = (typeof TherapistReportStatus)[keyof typeof TherapistReportStatus]


export const TherapistReportLanguage = {
  SR: 'SR',
  EN: 'EN'
} as const

export type TherapistReportLanguage = (typeof TherapistReportLanguage)[keyof typeof TherapistReportLanguage]


export const ChatMessageType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  THERAPY_REJECTED: 'THERAPY_REJECTED',
  THERAPY_ACCEPTED: 'THERAPY_ACCEPTED',
  SESSION_SCHEDULED: 'SESSION_SCHEDULED',
  THERAPY_REQUESTED_SESSION_SCHEDULED_AND_PAID: 'THERAPY_REQUESTED_SESSION_SCHEDULED_AND_PAID',
  QUIZ_SHARED: 'QUIZ_SHARED',
  FILE_SHARED: 'FILE_SHARED',
  SYSTEM_MESSAGE: 'SYSTEM_MESSAGE',
  PROPOSE_SESSION: 'PROPOSE_SESSION',
  THERAPIST_REPORT_PAYMENT_REQUEST: 'THERAPIST_REPORT_PAYMENT_REQUEST'
} as const

export type ChatMessageType = (typeof ChatMessageType)[keyof typeof ChatMessageType]


export const SessionReviewIdentityMode = {
  MASKED: 'MASKED',
  PUBLIC: 'PUBLIC',
  ANONYMOUS: 'ANONYMOUS'
} as const

export type SessionReviewIdentityMode = (typeof SessionReviewIdentityMode)[keyof typeof SessionReviewIdentityMode]


export const TherapySessionType = {
  IN_PERSON: 'IN_PERSON',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO'
} as const

export type TherapySessionType = (typeof TherapySessionType)[keyof typeof TherapySessionType]


export const TherapySessionStatus = {
  SCHEDULED: 'SCHEDULED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED'
} as const

export type TherapySessionStatus = (typeof TherapySessionStatus)[keyof typeof TherapySessionStatus]


export const TherapySessionBillingType = {
  B2C: 'B2C',
  B2B: 'B2B',
  FREE: 'FREE',
  AI_NON_BILLABLE: 'AI_NON_BILLABLE',
  PLATFORM_COMPED: 'PLATFORM_COMPED'
} as const

export type TherapySessionBillingType = (typeof TherapySessionBillingType)[keyof typeof TherapySessionBillingType]


export const TherapySessionPurpose = {
  THERAPY: 'THERAPY',
  INTRO_CALL: 'INTRO_CALL'
} as const

export type TherapySessionPurpose = (typeof TherapySessionPurpose)[keyof typeof TherapySessionPurpose]


export const PayoutStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  REFUNDED: 'REFUNDED'
} as const

export type PayoutStatus = (typeof PayoutStatus)[keyof typeof PayoutStatus]


export const ComplaintStatus = {
  PENDING: 'PENDING',
  UNDER_REVIEW: 'UNDER_REVIEW',
  RESOLVED: 'RESOLVED',
  DISMISSED: 'DISMISSED'
} as const

export type ComplaintStatus = (typeof ComplaintStatus)[keyof typeof ComplaintStatus]


export const QuizGenerationStatus = {
  PENDING: 'PENDING',
  GENERATING: 'GENERATING',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
} as const

export type QuizGenerationStatus = (typeof QuizGenerationStatus)[keyof typeof QuizGenerationStatus]


export const AIMessageRole = {
  system: 'system',
  user: 'user',
  assistant: 'assistant',
  data: 'data'
} as const

export type AIMessageRole = (typeof AIMessageRole)[keyof typeof AIMessageRole]


export const DiscountUserType = {
  NEW_USERS: 'NEW_USERS',
  EXISTING_USERS: 'EXISTING_USERS',
  ALL_USERS: 'ALL_USERS'
} as const

export type DiscountUserType = (typeof DiscountUserType)[keyof typeof DiscountUserType]


export const AiPlanTier = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  PASS_30D: 'PASS_30D',
  PASS_LEGACY: 'PASS_LEGACY'
} as const

export type AiPlanTier = (typeof AiPlanTier)[keyof typeof AiPlanTier]


export const AiPlanStatus = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  REFUNDED: 'REFUNDED'
} as const

export type AiPlanStatus = (typeof AiPlanStatus)[keyof typeof AiPlanStatus]


export const AiConversationStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
} as const

export type AiConversationStatus = (typeof AiConversationStatus)[keyof typeof AiConversationStatus]


export const GiftCardStatus = {
  PENDING: 'PENDING',
  REDEEMED: 'REDEEMED',
  EXPIRED: 'EXPIRED',
  REFUNDED: 'REFUNDED'
} as const

export type GiftCardStatus = (typeof GiftCardStatus)[keyof typeof GiftCardStatus]


export const CreditTransactionType = {
  GIFT_CARD_REDEEMED: 'GIFT_CARD_REDEEMED',
  REFUND: 'REFUND',
  PROMOTIONAL_CREDIT: 'PROMOTIONAL_CREDIT',
  SESSION_PURCHASE: 'SESSION_PURCHASE',
  EXPIRED: 'EXPIRED'
} as const

export type CreditTransactionType = (typeof CreditTransactionType)[keyof typeof CreditTransactionType]


export const OrganisationMemberRole = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
} as const

export type OrganisationMemberRole = (typeof OrganisationMemberRole)[keyof typeof OrganisationMemberRole]


export const BlogReviewStatus = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type BlogReviewStatus = (typeof BlogReviewStatus)[keyof typeof BlogReviewStatus]


export const ConcernTier = {
  PRIMARY: 'PRIMARY',
  ADDITIONAL: 'ADDITIONAL'
} as const

export type ConcernTier = (typeof ConcernTier)[keyof typeof ConcernTier]


export const PracticeTrainingStatus = {
  COMPLETED: 'COMPLETED',
  IN_TRAINING: 'IN_TRAINING',
  UNKNOWN: 'UNKNOWN'
} as const

export type PracticeTrainingStatus = (typeof PracticeTrainingStatus)[keyof typeof PracticeTrainingStatus]
